export const getShortenId = (id: string, type: 'short' | 'long' = 'short'): string => {
  if (id.length <= 10) return id
  if (type === 'short') {
    return `${id.slice(0, 3)}...${id.slice(-5)}`
  }
  if (type === 'long') {
    return `${id.slice(0, 7)}...${id.slice(-9)}`
  }
  return id
}
